import React from "react";
import { useLanguage } from "../../../components/ui/LanguageProvider";
import type { LocalizedText } from "../../../components/ui/LanguageProvider";

export type FeatureStatus =
  | "active"
  | "beta"
  | "development"
  | "coming_soon"
  | "admin_only"
  | "integration_required";

type Props = {
  status: FeatureStatus;
  size?: "sm" | "md";
};

const CONFIG: Record<FeatureStatus, { label: LocalizedText; bg: string; color: string; border: string }> = {
  active: {
    label: { ko: "사용 가능", en: "Available" },
    bg: "var(--success-soft)",
    color: "var(--success)",
    border: "var(--success-border)",
  },
  // Vault UI 노랑 알약 — 글자는 *-strong(대비 4.5:1). 테두리 없음.
  beta: {
    label: { ko: "Beta", en: "Beta" },
    bg: "var(--warning-subtle)",
    color: "var(--warning-strong)",
    border: "transparent",
  },
  development: {
    label: { ko: "개발 중", en: "In Development" },
    bg: "var(--warning-soft)",
    color: "var(--warning)",
    border: "var(--warning-border)",
  },
  coming_soon: {
    label: { ko: "개발 중", en: "In Development" },
    bg: "var(--warning-soft)",
    color: "var(--warning)",
    border: "var(--warning-border)",
  },
  admin_only: {
    label: { ko: "관리자 전용", en: "Admin Only" },
    bg: "var(--accent-soft)",
    color: "var(--accent)",
    border: "var(--accent-border)",
  },
  integration_required: {
    label: { ko: "연동 필요", en: "Integration Required" },
    bg: "var(--danger-soft)",
    color: "var(--danger)",
    border: "var(--danger-border)",
  },
};

export default function FeatureStatusBadge({ status, size = "md" }: Props) {
  const { t } = useLanguage();
  const cfg = CONFIG[status];
  // sm = 사이드바·목록 줄 안의 알약(높이 18px · 12px/600). 최소 글자 12px(DESIGN-AI).
  const padding = size === "sm" ? "0 6px" : "2px 9px";
  const fontSize = 12;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding,
        height: size === "sm" ? 18 : undefined,
        lineHeight: size === "sm" ? "16px" : undefined,
        boxSizing: "border-box",
        borderRadius: "var(--radius-pill)",
        fontSize,
        fontWeight: 600,
        background: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.border}`,
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {t(cfg.label)}
    </span>
  );
}
